/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The query params used for the Logs screen
 */
export const LogsQuery = {
  date: {
    from: 'date[from]',
    range: 'date[range]',
    to: 'date[to]',
  },
  filter: {
    query: 'filter[query]',
    tag: 'filter[tag]',
  },
};
